module.exports = __webpack_public_path__ + "img/zst2.f0d26b5e.jpg";